import {
  FileRows,
  ParseRows,
} from '@/app/features/products/common/components/file-selection/models';
import { parse as papaParse, ParseResult, ParseError, Parser } from 'papaparse';
import { FieldDelimiter } from '@ssar-app/domain';

const DelimitersMap: Record<string, FieldDelimiter> = {
  ',': FieldDelimiter.COMMA,
  '|': FieldDelimiter.PIPE,
  '\\t': FieldDelimiter.TAB,
};

export const parseRows = (
  inputFile: string | File,
  loadLimit = 25,
): Promise<ParseRows> => {
  let scannedRowsCount = 0;
  const toReturn: FileRows = [];
  return new Promise((resolve, reject) => {
    let detectedFieldDelimiter: FieldDelimiter;
    let error: Error | undefined;
    papaParse(inputFile, {
      worker: false,
      skipEmptyLines: true,
      header: false,
      // preview: 100,
      complete: (_results, _file) => {
        resolve({
          data: toReturn,
          scannedRowsCount,
        });
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      step: (results: ParseResult<any>, parser: Parser) => {
        if (error) {
          reject(error);
        }
        if (scannedRowsCount < 25) {
          toReturn.push(results.data);
        }
        if (scannedRowsCount >= loadLimit) {
          parser.abort();
        } else {
          if (!detectedFieldDelimiter) {
            const delimiter: FieldDelimiter | undefined =
              DelimitersMap[results?.meta?.delimiter];
            if (delimiter) {
              detectedFieldDelimiter = delimiter;
            } else {
              reject(
                new Error(
                  `Selected file doesn't have valid delimiter. Allowed delimiters: ${Object.keys(
                    DelimitersMap,
                  ).join(' or ')}`,
                ),
              );
            }
          }
          const { errors } = results;
          if (errors && errors.length) {
            reject(errors[0]);
          } else {
            scannedRowsCount++;
          }
        }
      },
      error: (error: ParseError) => {
        reject(error);
      },
    });
  });
};
